import React from 'react'

import { OutdatedData } from '#/components/OutdatedData'
import { minutesToHours } from '#/utils'

const MonitoringStatus = props => {
  let { value, invertColors, withMinutesToHours = true } = props
  let { timestamp } = props

  const invertColorsStyle = invertColors ? { color: '#fff' } : null

  if (withMinutesToHours) {
    value = (
      <span>
        {value} ({minutesToHours(value)})
      </span>
    )
  }

  return (
    <OutdatedData timestamp={timestamp} style={invertColorsStyle}>
      {value}
    </OutdatedData>
  )
}

export default MonitoringStatus
